import { render, staticRenderFns } from "./Peringatan.vue?vue&type=template&id=696f1388&scoped=true&"
import script from "./Peringatan.vue?vue&type=script&lang=js&"
export * from "./Peringatan.vue?vue&type=script&lang=js&"
import style0 from "./Peringatan.vue?vue&type=style&index=0&id=696f1388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696f1388",
  null
  
)

export default component.exports